import { colors, sizes, styleFragments } from '../../variables.style'
import { createUseStyles } from 'react-jss'

export const style = {
  button: {
    ...styleFragments.baseBodyFont,
    backgroundColor: 'var(--theme-action-pri-bg)',
    color: 'var(--theme-action-pri-fg)',
    borderRadius: '4px',
    border: `1px solid var(--theme-action-pri-bdr)`,
    display: 'inline-block',
    cursor: 'pointer',
    padding: '6px 15px',
    textDecoration: 'none',
    minHeight: sizes.buttonHeight,
    fontFamily: 'Arial,sans-serif',

    '&:hover, &:focus, &.active': {
      color: 'var(--theme-action-pri-bg)',
      backgroundColor: 'var(--theme-action-pri-fg)',
      outline: 'none'
    },

    '&:disabled': {
      opacity: '0.4',
      cursor: 'not-allowed',

      '&:hover, &:focus': {
        color: 'white',
        border: `1px solid var(--theme-brand-primary)`,
        backgroundColor: 'var(--theme-brand-primary)'
      },

      '& > *': {
        pointerEvents: 'none'
      }
    }
  },
  link: {
    extend: 'button',
    backgroundColor: 'transparent',
    border: 'transparent',
    color: 'black',
    fontSize: '14px',
    textDecoration: 'underline',

    '&:hover, &:focus, &.active': {
      color: 'var(--theme-action-pri-fg)',
      backgroundColor: 'transparent'
    },

    '&:disabled': {
      '&:hover, &:focus': {
        color: 'black',
        backgroundColor: 'transparent'
      }
    }
  },
  linkSansDecoration: {
    extend: 'button',
    padding: '0px 0px',
    backgroundColor: 'transparent',
    border: 'transparent',
    color: 'black',
    fontSize: '12px',
    textDecoration: 'none',
    '&:hover, &:focus, &.active': {
      backgroundColor: 'transparent'
    },

    '&:disabled': {
      '&:hover, &:focus': {
        color: 'black',
        backgroundColor: 'transparent'
      }
    }
  },
  inlineLink: {
    extend: 'link',
    padding: 0,
    display: 'inline',
    height: 'auto',
    color: 'inherit',
    fontFamily: '"Barlow", san-serif'
  },
  secondary: {
    extend: 'button',
    color: 'var(--theme-action-sec-fg)',
    backgroundColor: 'var(--theme-action-sec-bg)',
    border: `1px solid var(--theme-action-sec-bdr)`,

    '&:hover, &:focus, &.active': {
      backgroundColor: 'var(--theme-action-sec-fg)',
      color: 'var(--theme-action-sec-bg)'
    },

    '&:disabled': {
      '&:hover, &:focus': {
        color: 'white',
        backgroundColor: 'var(--theme-action-sec-bg)'
      }
    }
  },
  iconSecondary: {
    extend: 'button',
    color: 'var(--theme-action-sec-fg)',
    backgroundColor: 'var(--theme-action-sec-bg)',
    borderColor: 'var(--theme-action-sec-bdr)',
    padding: '6px 10px',

    '&:hover, &:focus': {
      color: 'var(--theme-action-sec-bg)',
      backgroundColor: 'var(--theme-action-sec-fg)'
    },

    '&:disabled': {
      '&:hover, &:focus': {
        backgroundColor: 'var(--theme-action-sec-bg)'
      }
    }
  },
  mini: {
    backgroundColor: 'transparent',
    color: 'var(--theme-brand-primary)',
    border: `1px solid var(--theme-brand-primary)`,
    display: 'inline-block',
    cursor: 'pointer',
    padding: '5px 8px 4px 12px;',
    textDecoration: 'none',
    textTransform: 'uppercase',
    fontSize: '12px',
    borderRadius: '16px',

    '&:hover, &:focus': {
      color: 'white',
      borderColor: 'var(--theme-brand-primary)',
      backgroundColor: 'var(--theme-brand-primary)',
      outline: 'none'
    }
  },
  miniPageList: {
    backgroundColor: 'transparent',
    color: 'var(--theme-action-sec-fg)',
    border: 'none',
    display: 'inline-block',
    cursor: 'pointer',
    padding: '5px 0px 5px 0px;',
    textDecoration: 'none',
    textTransform: 'uppercase',
    borderRadius: '0px',

    '&:hover, &:focus': {
      color: 'white',
      borderColor: 'var(--theme-action-sec-bdr)',
      backgroundColor: 'var(--theme-action-sec-fg)',
      outline: 'none'
    }
  },
  miniSecondary: {
    extend: 'mini',
    borderColor: 'black',
    backgroundColor: 'white'
  },
  large: {
    height: sizes.textInputHeight,
    padding: '11px 15px'
  }
}

export const useStyles = createUseStyles(style)
